/*
 * Copyright (c) 2013 SGS Europe. All rights reserved.
 *
 * This program is the CONFIDENTIAL and PROPRIETARY property of 2013 SGS Europe.
 * Any unauthorised use, reproduction, or transfer of this program is strictly
 * prohibited.
 *
 * File Name:	ContentLoader.js
 *
 * Description:	Provides an interface for making HTTP requests (Ajax/Fetch) and loading
 *				content into DOM elements. All modern callers should use the Fetch-based
 *				functions (upload_fetch, uploadJSON_fetch, loadContent_fetch). Legacy
 *				jQuery-based functions remain for backward compatibility but are deprecated.
 */

/**
 * @type {object}
 * Global store for the most recent response data returned by an Ajax or Fetch request.
 * Set as a side effect by several upload functions. Prefer using the callback argument
 * to access response data rather than reading this global directly.
 */
var g_oCLData = new Object();

/**
 * POSTs JSON-serialised data to the server using the Fetch API and delivers the raw
 * response text to the callback. Appends Action and LoginId as query parameters.
 * The response text is also stored in the global g_oCLData.
 *
 * Use this function when the server returns plain text or HTML. For JSON responses
 * with structured error handling, prefer uploadJSON_fetch.
 *
 * @param {string}   server   - The base server URL (without query string).
 * @param {string}   action   - The Action query parameter value sent to the server.
 * @param {any}      data     - Data to serialise to JSON and POST to the server.
 * @param {Function} callback - Invoked with the raw response text string on success.
 *                              May be null if no post-request action is needed.
 */
function upload_fetch(server, action, data, callback) {
	fetch(server + "?Action=" + action + "&LoginId=" + g_oUserProfile.loginId, {
		method: 'POST',
		headers: {
			'Accept': 'application/json, text/plain, */*',
			'Content-Type': 'application/json'
		},
		credentials: 'same-origin',
		body: JSON.stringify(data)
	}).then(function (res) {
		return res.text();
	})
	.then(function (res) {
		g_oCLData = res;
		if (callback) {
			callback(res);
		}
	});
}

/**
 * POSTs JSON-serialised data to the server using the Fetch API and delivers the parsed
 * JSON response to the callback. Appends Action and LoginId as query parameters.
 * Handles HTTP-level errors, application-level errors (res.Success === false), network
 * failures, and development-environment re-throws. The response is also stored in g_oCLData.
 *
 * This is the preferred function for all authenticated JSON POST requests.
 *
 * @param {string}   server   - The base server URL (without query string).
 * @param {string}   action   - The Action query parameter value sent to the server.
 * @param {any}      data     - Data to serialise to JSON and POST to the server.
 * @param {Function} callback - Invoked with the parsed JSON response object on success.
 *                              May be null if no post-request action is needed.
 * @param {Function} onError  - Invoked when the HTTP response is not ok, when the response
 *                              contains Success === false, or when a network error occurs.
 *                              Receives the error object or response as its argument.
 *                              May be null if error handling is not required.
 */
function uploadJSON_fetch(server, action, data, callback, onError) {
	fetch(server + "?Action=" + action + "&LoginId=" + g_oUserProfile.loginId, {
		method: 'POST',
		headers: {
			'Accept': 'application/json, text/plain, */*',
			'Content-Type': 'application/json'
		},
		credentials: 'same-origin',
		body: JSON.stringify(data)
	}).then(function (res) {
		if (onError && !res.ok) {
			throw Error(response.statusText);
		}

		return res.json();
	})
	.then(function (res) {
		if (onError && res.Success == false) {
			onError(res);
		}
		else {
			g_oCLData = res;
			if (callback) {
				callback(res);
			}
		}
	}).catch(function (error) {
		reportDevError("Network error calling: " + server + " - with action: " + action, { res: error, payload: data });
		if (onError) onError(error);
		if (window.location.href.startsWith('https://localhost:44300')) {
			throw (error);
		}
	});
}

/**
 * POSTs JSON-serialised data to the server using the Fetch API, injects the HTML response
 * text into a DOM element, and optionally invokes a callback on completion. Appends Action
 * and LoginId as query parameters. Handles HTTP-level errors and network failures.
 *
 * This is the preferred function for loading server-rendered HTML fragments into the page.
 *
 * @param {string}   elementId - The ID of the DOM element to inject the response HTML into.
 * @param {string}   server    - The base server URL (without query string).
 * @param {string}   action    - The Action query parameter value sent to the server.
 * @param {any}      data      - Data to serialise to JSON and POST to the server.
 * @param {Function} callback  - Invoked with (responseText, elementId) after the HTML has
 *                               been injected. May be null if no post-load action is needed.
 * @param {Function} onError   - Invoked when the HTTP response is not ok or a network error
 *                               occurs. Receives the error object or response as its argument.
 *                               May be null if error handling is not required.
 */
function loadContent_fetch(elementId, server, action, data, callback, onError) {
	fetch(server + "?Action=" + action + "&LoginId=" + g_oUserProfile.loginId, {
		method: 'POST',
		headers: {
			'Accept': 'application/json, text/plain, */*',
			'Content-Type': 'application/json'
		},
		credentials: 'same-origin',
		body: JSON.stringify(data)
	}).then(function (res) {
		if (onError && !res.ok) {
			onError(res);
		}

		return res.text();
	}).then(function (res) {
		$("#" + elementId).html(res);
		if (callback) {
			callback(res, elementId);
		}
	}).catch(function (error) {
		reportDevError("Network error calling: " + server + " - with action: " + action, { res: error, payload: data });
		if (onError) onError(error);
		if (window.location.href.startsWith('https://localhost:44300')) {
			throw(error);
		}
	});
}

// #region DEPRECATED

/**
 * Loads the HTML result of an HTTP GET/POST request into a DOM element.
 * Appends Action and LoginId as query parameters. The callback is passed as a string
 * and executed via eval() after the request completes.
 *
 * @param {string} element    - The ID of the DOM element to inject the response HTML into.
 * @param {string} server     - The base server URL (without query string).
 * @param {string} action     - The Action query parameter value sent to the server.
 * @param {any}    data       - POST data sent with the request.
 * @param {string} callback   - A string of JavaScript to be evaluated after the request completes.
 *
 * @deprecated Use loadContent_fetch instead. This function relies on jQuery .load() and
 *             executes the callback via eval(), which is a security risk and prevents
 *             static analysis. Pass a proper function reference to loadContent_fetch.
 */
function loadContent(element, server, action, data, callback) {

	// Set to allow caching of content downloaded as part of the Ajax call.
	$.ajaxSetup({

		cache: true
	});
	$("#" + element).load(server + "?Action=" + action + "&LoginId=" + g_oUserProfile.loginId, data, function (responseText, textStatus, XMLHttpRequest) {
		eval(callback);
	});
}

/**
 * Loads the HTML result of an HTTP GET/POST request into a DOM element.
 * Appends Action and LoginId as query parameters. The callback receives the raw
 * response text as its only argument.
 *
 * @param {string}   element - The ID of the DOM element to inject the response HTML into.
 * @param {string}   server  - The base server URL (without query string).
 * @param {string}   action  - The Action query parameter value sent to the server.
 * @param {any}      data    - POST data sent with the request.
 * @param {Function} func    - Callback invoked with (responseText) when the request completes.
 *
 * @deprecated Use loadContent_fetch instead. This function relies on the jQuery .load()
 *             method which performs an implicit DOM injection and does not support modern
 *             error handling or promise chaining.
 */
function loadContentFunc(element, server, action, data, func) {

	// Set to allow caching of content downloaded as part of the Ajax call.
	$.ajaxSetup({
		cache: true
	});
	$("#" + element).load(server + "?Action=" + action + "&LoginId=" + g_oUserProfile.loginId, data, function (responseText, textStatus, XMLHttpRequest) {
		func(responseText);
	});
}

/**
 * Loads the HTML result of an HTTP GET/POST request into a DOM element with no callback.
 * Appends Action and LoginId as query parameters. Use when the response content only needs
 * to be injected and no post-load logic is required.
 *
 * @param {string} element - The ID of the DOM element to inject the response HTML into.
 * @param {string} server  - The base server URL (without query string).
 * @param {string} action  - The Action query parameter value sent to the server.
 * @param {any}    data    - POST data sent with the request.
 *
 * @deprecated Use loadContent_fetch instead. This function relies on the jQuery .load()
 *             method and provides no error handling or completion notification.
 */
function loadContentEx(element, server, action, data) {

	// Set to allow caching of content downloaded as part of the Ajax call.
	$.ajaxSetup({
		cache: true
	});
	$("#" + element).load(server + "?Action=" + action + "&LoginId=" + g_oUserProfile.loginId, data, function (responseText, textStatus, XMLHttpRequest) {
	});
}

/**
 * Posts data to the server using $.postJSON and evaluates the callback string on completion.
 * The response is also stored in the global g_oCLData.
 *
 * @param {string} server   - The base server URL (without query string).
 * @param {string} action   - The Action query parameter value sent to the server.
 * @param {any}    data     - Data to POST to the server.
 * @param {string} callback - A string of JavaScript to be evaluated after the request completes.
 *
 * @deprecated Use uploadJSON_fetch instead. This function relies on the non-standard
 *             $.postJSON jQuery extension and executes the callback via eval(), which is
 *             a security risk and prevents static analysis.
 */
function uploadContent(server, action, data, callback) {

	$.postJSON(server + "?Action=" + action + "&LoginId=" + g_oUserProfile.loginId, data, function (data) {
		g_oCLData = data;
		eval(callback);
	});
}

/**
 * Posts data to the server using $.postJSON and invokes the callback function with the
 * parsed response. The response is also stored in the global g_oCLData.
 *
 * @param {string}   server   - The base server URL (without query string).
 * @param {string}   action   - The Action query parameter value sent to the server.
 * @param {any}      data     - Data to POST to the server.
 * @param {Function} callback - Callback invoked with the parsed JSON response on success.
 *
 * @deprecated Use uploadJSON_fetch instead. This function relies on the non-standard
 *             $.postJSON jQuery extension and has no error handling path.
 */
function uploadContent_func(server, action, data, callback) {

	$.postJSON(server + "?Action=" + action + "&LoginId=" + g_oUserProfile.loginId, data, function (data) {
		g_oCLData = data;
		callback(data);
	});
}

/**
 * Serialises data to JSON, POSTs it to the server using $.postJSON, and evaluates the
 * callback string on completion. Returns the underlying XHR object so the caller can
 * cancel the request if needed. The response is also stored in the global g_oCLData.
 *
 * @param {string} server   - The base server URL (without query string).
 * @param {string} action   - The Action query parameter value sent to the server.
 * @param {any}    data     - Data to serialise to JSON and POST to the server.
 * @param {string} callback - A string of JavaScript to be evaluated after the request completes.
 * @returns {jqXHR} The jQuery XHR object, which can be used to abort the in-flight request.
 *
 * @deprecated Use uploadJSON_fetch instead. This function relies on the non-standard
 *             $.postJSON jQuery extension and executes the callback via eval(), which is
 *             a security risk and prevents static analysis.
 */
function uploadJSON(server, action, data, callback) {

	return $.postJSON(server + "?Action=" + action + "&LoginId=" + g_oUserProfile.loginId, JSON.stringify(data), function (data) {
		g_oCLData = data;
		eval(callback);
	});
}

/**
 * Anonymous variant of uploadJSON. Serialises data to JSON and POSTs it to the server
 * using $.postJSON with LoginId hard-coded to 0. Used for endpoints that do not require
 * authentication. The response is also stored in the global g_oCLData.
 *
 * @param {string} server   - The base server URL (without query string).
 * @param {string} action   - The Action query parameter value sent to the server.
 * @param {any}    data     - Data to serialise to JSON and POST to the server.
 * @param {string} callback - A string of JavaScript to be evaluated after the request completes.
 * @returns {jqXHR} The jQuery XHR object, which can be used to abort the in-flight request.
 *
 * @deprecated Use uploadJSON_fetch instead (with LoginId omitted or set to 0 at the server
 *             level). This function relies on the non-standard $.postJSON jQuery extension
 *             and executes the callback via eval(), which is a security risk.
 */
function uploadJSON_Anon(server, action, data, callback) {

	return $.postJSON(server + "?Action=" + action + "&LoginId=0", JSON.stringify(data), function (data) {
		g_oCLData = data;
		eval(callback);
	});
}

/**
 * POSTs JSON-serialised data to the server synchronously using $.ajax with async: false,
 * then parses and returns the JSON response inline.
 *
 * WARNING: Synchronous XHR blocks the browser's main thread for the full duration of the
 * request, freezing all UI interaction and script execution. There is no valid use case
 * for this in a browser context. Refactor callers to use uploadJSON_fetch with a callback.
 *
 * @param {string} server  - The base server URL (without query string).
 * @param {string} action  - The Action query parameter value sent to the server.
 * @param {any}    data    - Data to serialise to JSON and POST to the server.
 * @returns {object} The parsed JSON response object.
 *
 * @deprecated This function performs a synchronous XMLHttpRequest which blocks the main
 *             thread and is flagged as deprecated by browser vendors. Use uploadJSON_fetch
 *             with a proper callback instead.
 */
function uploadJSON_sync(server, action, data) {
	var x = $.ajax({
		type: "POST",
		url: server
			+ "?Action=" + action
			+ "&LoginId=" + g_oUserProfile.loginId,
		async: false,
		data: JSON.stringify(data)
	}).responseText;

	return JSON.parse(x);
}

// #endregion DEPRECATED
